import { MMediaSelectorProps } from '../../molecules/MMediaSelector/MMediaSelector.types';
import { MButtonOverlayProps } from '../../molecules/MButtonOverlay/MButtonOverlay.types';

export enum OCarouselGalleryHeroImageScale {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export enum OCarouselGalleryHeroMediaType {
  Image = 'Image',
  ModalVideo = 'Modal Video',
  AutoplayVideo = 'Autoplay Video',
}

export enum OCarouselGalleryHeroCarouselType {
  Dots = 'Dots',
  Numbers = 'Numbers',
}

export interface OCarouselGalleryHeroTrackingProperties {
  additionalTrackingVariables?: string;
  enableScrollingBehavior?: boolean;
  trackingDescription?: string;
  impressionTrack?: string | null;
  description?: string;
  trackingContentPosition?: string;
  faicMCD?: string;
  atCCeVar48?: string;
  rightArrowDesc?: string;
  cardLocation?: string;
  leftArrowDesc?: string;
  clickTrack?: string | null;
  location?: string;
  merchandisingCategory?: string;
  impressionCount?: number | null;
  trackingTag?: string;
  trackingOfferType?: string;
}

export interface OCarouselGalleryHeroProps extends React.HTMLAttributes<HTMLDivElement> {
  imageScale?: OCarouselGalleryHeroImageScale;
  mediaType?: OCarouselGalleryHeroMediaType;
  carouselType?: OCarouselGalleryHeroCarouselType;
  gallery?: boolean;
  virtualTour?: boolean;
  isAuthorMode?: boolean;
  mMediaSelectorMulti?: MMediaSelectorProps[];
  mButtonOverlayGallery?: Omit<MButtonOverlayProps, 'imageOverlay'>;
  mButtonOverlayVirtualTour?: Omit<MButtonOverlayProps, 'imageOverlay'>;
  trackingProperties?: OCarouselGalleryHeroTrackingProperties;
  cqPath?: string;
  className?: string;
}
